import Modal from 'react-bootstrap/Modal';

export function ModalApp({
                             children,
                             show,
                             handleModal,
                             centered,
                             size,
                             closeButton,
                             headerTitle
                         }) {
    return (
        <Modal
            show={show}
            onHide={handleModal}
            backdrop="static"
            keyboard={false}
            centered={centered}
            size={size}
        >
            {closeButton && (
                <Modal.Header closeButton>
                    <Modal.Title className="d-flex justify-content-center w-100 fs-6">
                         {headerTitle}
                    </Modal.Title>
                </Modal.Header>
            )}
            <Modal.Body className="p-0">{children}</Modal.Body>
        </Modal>
    );
}
